export default "__VITE_ASSET__166afb72__"